import { jsx, jsxs } from "react/jsx-runtime";
import { Button, Input, TextArea, XStack, YStack } from "tamagui";
function InputsDemo() {
  return /* @__PURE__ */ jsxs(
    YStack,
    {
      width: 200,
      minHeight: 250,
      overflow: "hidden",
      space: "$2",
      margin: "$3",
      padding: "$2",
      children: [
        /* @__PURE__ */ jsx(InputDemo, { size: "$2" }),
        /* @__PURE__ */ jsx(InputDemo, { size: "$3" }),
        /* @__PURE__ */ jsx(InputDemo, { size: "$4" }),
        /* @__PURE__ */ jsx(TextArea, { minHeight: 140, placeholder: "Enter your details...", numberOfLines: 4 })
      ]
    }
  );
}
function InputDemo(props) {
  return /* @__PURE__ */ jsxs(XStack, { alignItems: "center", space: "$2", children: [
    /* @__PURE__ */ jsx(Input, { flex: 1, size: props.size, placeholder: `Size ${props.size}...` }),
    /* @__PURE__ */ jsx(Button, { size: props.size, children: "Go" })
  ] });
}
export {
  InputsDemo
};
//# sourceMappingURL=InputsDemo.js.map
